// assets/js/book-place.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const isEditor = document.body.classList.contains("wp-admin");
if (!isEditor) gsap.registerPlugin(ScrollTrigger);

function initBookPlace(section) {
  if (!section || section.__bpInit) return;
  section.__bpInit = true;

  const headline = section.querySelector(".book-place__headline");
  const leftText = section.querySelector(".book-place__text");
  const cta = section.querySelector(".book-place__cta");
  const rightIntro = section.querySelector(".book-place__right-intro");
  const cards = section.querySelectorAll(".book-place__card");

  gsap.set([headline, leftText, cta, rightIntro], { opacity: 0, y: 18 });
  if (cards.length) gsap.set(cards, { opacity: 0, y: 14 });

  const tlOpts = isEditor
    ? { defaults: { ease: "power3.out" } }
    : {
        defaults: { ease: "power3.out" },
        scrollTrigger: {
          trigger: section,
          start: "top 78%",
          once: true,
        },
      };

  const tl = gsap.timeline(tlOpts);

  if (headline) tl.to(headline, { opacity: 1, y: 0, duration: 0.7 });
  if (leftText) tl.to(leftText, { opacity: 1, y: 0, duration: 0.55 }, "-=0.35");
  if (cta) tl.to(cta, { opacity: 1, y: 0, duration: 0.45 }, "-=0.25");
  if (rightIntro)
    tl.to(rightIntro, { opacity: 1, y: 0, duration: 0.5 }, "-=0.2");

  if (cards.length) {
    tl.to(cards, { opacity: 1, y: 0, duration: 0.45, stagger: 0.08 }, "-=0.25");
  }
}

const mount = () => {
  if (!isEditor) {
    document.querySelectorAll(".book-place").forEach(initBookPlace);
    return;
  }

  const root = document.querySelector(".editor-styles-wrapper") || document;
  const run = () => root.querySelectorAll(".book-place").forEach(initBookPlace);

  run();
  const mo = new MutationObserver(run);
  mo.observe(root, { childList: true, subtree: true });
};

if (window.wp?.domReady) window.wp.domReady(mount);
else document.addEventListener("DOMContentLoaded", mount);
